import { render, staticRenderFns } from "./omSystem.vue?vue&type=template&id=0ae7b31d&scoped=true&"
import script from "./omSystem.vue?vue&type=script&lang=js&"
export * from "./omSystem.vue?vue&type=script&lang=js&"
import style0 from "./omSystem.vue?vue&type=style&index=0&id=0ae7b31d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae7b31d",
  null
  
)

export default component.exports